import {
  dropdownContainerLogoClass,
  dropdownContainerLogoTextClass,
} from "chameleon/lib/components/dropdown-autocomplete/dropdown-autocomplete.css";

export type PoweredByType = {
  text: string;
  brand?: string;
  logo: {
    src: string;
    width: number;
    height: number;
  };
};

export const PoweredByFooter = ({
  poweredBy,
}: {
  poweredBy?: PoweredByType;
}) => {
  if (!poweredBy) return null;

  return (
    <div className={dropdownContainerLogoClass}>
      <span className={dropdownContainerLogoTextClass}>{poweredBy.text}</span>
      <img
        src={poweredBy.logo.src}
        width={poweredBy.logo.width}
        height={poweredBy.logo.height}
        alt={poweredBy.brand}
      />
    </div>
  );
};
